import styled from '../references';

export const Button = styled.div`
  background-color: ${props => props.theme.colors.brandMuted};
  color: ${props => props.theme.colors.foregroundActive};
  cursor: pointer;
  display: flex;
  font-size: 1em;
  padding: 0.75em 1.5em;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  transition: background-color 0.2s ease;
  user-select: none;
  white-space: nowrap;
  > * {
    display: block;
    margin-left: 3px;
  }
  > *:first-child {
    margin-left: 0px;
  }
  :hover {
    background-color: ${props => props.theme.colors.brand};
  }
  :active {
    background-color: darken(${props => props.theme.colors.brandMuted}, 10%);
  }
`;
